import { Directive, HostBinding, Input } from '@angular/core';

import { ResourceUrlHelper } from './resource-url-helper';

@Directive({
  selector: 'img[appResourceUrlHelper]',
})
export class ImageResourceUrlHelperDirective extends ResourceUrlHelper {
  @Input() appResourceUrlHelper = true;
  @HostBinding('src') override url: string;
  @Input() set placeholder(path: string | null) {
    if (path) {
      this.url = path;
    }
  }

  @Input() set src(path: string | null) {
    if (this.appResourceUrlHelper && path) {
      this.url = this.constructUrl(path);
    } else if (path) {
      this.url = path;
    }
  }
}
